import { Tab } from "@headlessui/react";
import Image from "next/image";
import React from "react";
import { motion } from "framer-motion";
import styles from "./AnimatedTabs.module.scss";

interface Props {
    index: number;
    children: React.ReactNode;
    popupImage?: {
        src: string;
        alt: string;
    };
    style?: React.CSSProperties;
}

const AnimatedTab: React.FC<Props> = ({
    index,
    style,
    popupImage,
    children,
}) => {
    return (
        <Tab as={React.Fragment}>
            {({ selected }) => (
                <button
                    className={`${styles.tab} ${selected ? styles.currentTab : ""}`}
                    style={{
                        ...style,
                        border: "none",
                        position: "relative",
                        outline: "none",
                    }}
                >
                    {popupImage && (
                        <div
                            className={`${styles.companyLogo} ${!selected ? styles.hidden : ""
                                }`}
                            style={{
                                position: "absolute",
                                height: "100%",
                                width: 100,
                                left: -120,
                                top: 0,
                            }}
                        >
                            <Image
                                src={popupImage.src}
                                alt={popupImage.alt}
                                fill
                                style={{ objectFit: "contain" }}
                            />
                        </div>
                    )}
                    {selected && (
                        <motion.div
                            layoutId="currentTabHighlighter"
                            className={styles.currentTabHighlighter}
                            initial={false}
                            transition={{
                                type: "spring",
                                stiffness: 500,
                                damping: 40,
                            }}
                        />
                    )}
                    {children}
                </button>
            )}
        </Tab>
    );
};

export default AnimatedTab;
